import { lazyPage } from './lazyPage';
import type { AppRoute } from './types';

// const EducationBoardsWorkspace = lazyPage(() => import('@/pages/administration/EducationBoardsWorkspace'));
const AuditLogs = lazyPage(() => import('@/pages/administration/AuditLogs'));
const GlobalSettings = lazyPage(() => import('@/pages/administration/globalSettings/GlobalSettings'));

// Administration · Education Boards: the boards the school's academic years
// follow, and the mediums it teaches in (one tab each).
// Administration · Audit Logs: who changed what, and when, across every module.
// Administration · Global Settings: organization defaults, school overrides and key formats.
export const administrationRoutes: AppRoute[] = [
//   {
//     path: 'education-boards',
//     title: 'Education Boards',
//     component: EducationBoardsWorkspace,
//     
//   },
  {
    path: 'audit-logs',
    title: 'Audit Logs',
    component: AuditLogs,
  },
  {
    path: 'global-settings',
    title: 'Global Settings',
    component: GlobalSettings,
  },
];
